import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Pagination from "../../../entities/Pagination";
import DeliveryPerson from "../../../entities/DeliveryPerson";
import DeliveryCost from "../../../entities/DeliveryCost";
import {DeliveryCostService} from "../../../service/DeliveryCostService";
import Geo from "../../../entities/Geo";

class DeliveryCostButtonStore {

    public deliveryPerson: DeliveryPerson;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;
    public pagination: Pagination;
    public geoFilter?: Geo;
    public currencyFilter?: string;
    public costs: DeliveryCost[];


    public amountError?: string;


    constructor(commonStore: CommonStore, deliveryPerson: DeliveryPerson) {
        this.isModalOpen = false;
        this.deliveryPerson = deliveryPerson;
        this.loading = false;
        this.commonStore = commonStore;
        this.pagination = new Pagination(1, 15, 0, 0);
        this.costs = [];
        makeAutoObservable(this);
    }

    @action
    public async getPrices(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.loading = true;
        const response = await DeliveryCostService.get(page, pageSize, this.deliveryPerson.id, this.currencyFilter, this.geoFilter?.id);
        if (response.success) {
            runInAction(() => {
                this.costs = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public async openModal() {
        this.isModalOpen = true;
        await this.getPrices();
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async cleanFilter() {
        this.geoFilter = undefined;
        this.currencyFilter = undefined;
        await this.getPrices();
    }

    get isEmpty(): boolean {
        return this.costs.length === 0;
    }

    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getPrices(page, pageSize);
    }

}

export default DeliveryCostButtonStore;